$(document).ready(function () {

  // References from product-creator-utils.js
  var ORIGINAL_IMAGES = window.ORIGINAL_IMAGES;
  var _auth = window._creatorAuth;
  var customerId = window._creatorCustomerId;
  var customer_first_name = window._creatorCustomerFirstName;
  var customer_last_name = window._creatorCustomerLastName;
  var customer_name_split = window._creatorCustomerNameSplit;
  var showGlobalSpinner = window.CreatorUtils.showGlobalSpinner;
  var hideGlobalSpinner = window.CreatorUtils.hideGlobalSpinner;
  var updateBgStatus = window.CreatorUtils.updateBgStatus;
  // References from product-creator-preview.js
  var getProductLabel = window.PreviewModule.getProductLabel;
  var deepCloneDesignItems = window.PreviewModule.deepCloneDesignItems;
  var buildManifest = window.buildManifest;

  // References from product-creator-s3.js
  var uploadRemainingImagesToS3 = window.S3Upload.uploadRemainingImagesToS3;
  var extractVariantLogosToS3 = window.S3Upload.extractVariantLogosToS3;

  // References from product-creator-design-collector.js
  var DesignCollector = window.DesignCollector;

  // Warn user before navigating away during S3 upload (background).
  window.addEventListener("beforeunload", function(e) {
    if (window._s3UploadInProgress) {
      e.preventDefault();
      e.returnValue = "";
    }
  });

  /**
   * Fire the tiny process-creation-job trigger (uses keepalive to survive navigation).
   * Used by both the initial creation and the retry button.
   */
  function fireBatchCreation(orderFolder, LAMBDA_URL, $overlay) {
    // The group's own sheets, stored beside the order under the fixed keys
    // src/lib/customer-sheets.js reads them back by. Fired here because this is
    // the first point at which the order folder is final, and deliberately NOT
    // awaited: the creation is the deliverable and a sheet that fails to upload
    // must not hold it up or fail it. The lambda builds the Reconcile artifact
    // at the end of process-creation-job, by which time these are up; if one
    // loses the race, opening the tab rebuilds it.
    try {
      if (window.EgennavnUpload && window.EgennavnUpload.stashSourceSheets) {
        window.EgennavnUpload.stashSourceSheets(orderFolder, LAMBDA_URL, _auth)
          .then(function (done) {
            if (done && done.length) console.log("[creator] stored source sheets:", done.join(", "));
          });
      }
    } catch (e) {
      console.warn("[creator] source-sheet stash skipped:", e);
    }

    var triggerPayload = JSON.stringify({
      action: "process-creation-job",
      orderFolder: orderFolder,
      auth: _auth
    });

    fetch(LAMBDA_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: triggerPayload,
      keepalive: true
    }).then(function(res) {
      if (!res.ok) {
        throw new Error("Lambda returned " + res.status);
      }
      return res.json();
    }).then(function(result) {
      if (result.success) {
        $overlay.addClass("success-state");
        $("#preview-header-text").text("Products created!");
        updateBgStatus("success", "Products created!");
        $("#generate-rozpiska-btn, #download-section-zips-btn").show();
        if (result.collectionUrl) {
          $("#success-collection-link").attr("href", result.collectionUrl).show();
        }
        $("#success-btn-home").show();
        // The film, if the box was ticked. It runs on in the lambda after this
        // response, so creation reports its own success first and the film
        // reports separately underneath: a film failure is not a creation
        // failure and must never read as one.
        if (result.film && result.film.jobId && window.FtmFilm) {
          window.FtmFilm.watch(orderFolder, result.film.jobId);
        } else if (result.film && result.film.state === "queued" && window.FtmFilm) {
          // Since 2026-09-25 the print files render in the background after
          // creation returns (process-creation-render), and the film starts
          // once they exist, so there is no job id to follow from here yet.
          window.FtmFilm.report("Film queued: it starts once the print files are rendered (about 15 min). Follow it on the job page.");
        }
      } else if (result.skipped) {
        // Idempotent — already processed
        $overlay.addClass("success-state");
        $("#preview-header-text").text("Products created!");
        updateBgStatus("success", "Products already created!");
        $("#generate-rozpiska-btn, #download-section-zips-btn").show();
        $("#success-btn-home").show();
      } else {
        updateBgStatus("error", "Product creation failed");
        $("#success-btn-home").show();
      }
    }).catch(function(err) {
      console.error("Background product creation error:", err);
      updateBgStatus("error", "Something went wrong");
      $("#success-btn-home").show();
    });
  }

  // "Try again", for both creators. Until the creation trigger has gone out,
  // the failure was in the upload or the job.json save, and the lambda has
  // nothing to create from yet: run that background step again, which sends
  // only the images still missing (window._bgCreationRetry, set by whichever
  // creator is running). In Local mode the trigger never goes out, so this
  // re-runs the local save and render and never creates products. After the
  // trigger, re-send only the trigger.
  //
  // Until 2026-10-29 it always re-sent the trigger, so after "Upload failed"
  // the lambda was asked to create from a job.json nobody had written, and
  // failed every time.
  function retryBackgroundCreation() {
    if (window._bgCreationRetry) {
      $("#success-btn-home").hide();
      return window._bgCreationRetry();
    }
    if (!window._bgCreationOrderFolder || !window._bgCreationLambdaUrl) return;
    updateBgStatus("in-progress", "Retrying...");
    $("#success-btn-home").hide();
    var $overlay = $("#expansion-preview-overlay");
    fireBatchCreation(window._bgCreationOrderFolder, window._bgCreationLambdaUrl, $overlay);
  }
  $(document).on("click", "#bg-status-retry", retryBackgroundCreation);

  /**
   * Background: S3 upload → save-creation-job → trigger product creation.
   * Runs after the spinner is hidden and mockups are visible.
   * Progress is shown in the bg status bar, not the spinner.
   */
  // The Local pill, not the host. `FTM_IS_LOCAL_SITE()` is true on the local
  // site even with the pill on Cloud, and on Cloud the artwork really is in S3
  // and the products really should be created — same distinction ftm-config.js
  // draws for the login bypass. Same shape as ftm-local-drafts.js#localBackend.
  function ftmLocalBackend() {
    try {
      var v = window.localStorage && window.localStorage.getItem("FTM_LOCAL");
      return v ? String(v).replace(/\/$/, "") : null;
    } catch (e) {
      return null;
    }
  }

  async function runNavigationSafeCreation(opts) {
    var imageMap = opts.imageMap;
    var productsWithKeys = opts.productsWithKeys;
    var originalImagesKeys = opts.originalImagesKeys;
    var orderFolder = opts.orderFolder;
    var manifest = opts.manifest;
    var projectNameVal = opts.projectNameVal;
    var LAMBDA_URL = opts.LAMBDA_URL;
    var $overlay = opts.$overlay;
    var versionPrintFiles = opts.versionPrintFiles || {};
    var allDesignKeys = opts.designKeys || {};

    var keysToUrls = window.FTMShared.keysToUrls;
    var omitEmptySlots = window.FTMShared.omitEmptySlots;

    // "Try again" runs this whole function again until the trigger goes out
    // (retryBackgroundCreation). Kept across attempts: which images are
    // already in S3.
    var uploaded = opts.uploaded || (opts.uploaded = {});
    window._bgCreationRetry = function() { return runNavigationSafeCreation(opts); };

    try {
      // Step 1: Upload images to S3, those an earlier attempt did not send
      window._s3UploadInProgress = true;
      var totalImages = Object.keys(imageMap).filter(function(k) { return !uploaded[k]; }).length;
      updateBgStatus("in-progress", "Uploading images (0/" + totalImages + ")...");

      await uploadRemainingImagesToS3(imageMap, uploaded, LAMBDA_URL, function(done, total) {
        updateBgStatus("in-progress", "Uploading images (" + done + "/" + total + ")...");
      });

      window._s3UploadInProgress = false;
      console.log("Background: All " + totalImages + " images uploaded to S3");

      // Step 2: Build batch products with S3 URLs
      var finalOriginalImages = keysToUrls(originalImagesKeys);
      var batchProducts = productsWithKeys.map(function(p) {
        var productOriginalImages = finalOriginalImages;

        if (window.VersionManager && window.VersionManager.isVersionedId(p.productId)) {
          var pVer = window.VersionManager.getVersion(p.productId);
          var verPF = versionPrintFiles[p.productId];
          if (pVer && pVer.baseProductId === "hoodie") {
            var verHS = window.VersionManager.getHoodieState(p.productId);
            // Same rule as the base product: name only the slots this version's
            // collect pass actually wrote. A version can carry a hood the base
            // does not, or drop one it has.
            var verKeys = allDesignKeys[p.productId] || {};
            var verOriginalKeys = omitEmptySlots({
              front_image: verKeys.front_image,
              back_top: verKeys.back_top,
              back_hood_left: verKeys.back_hood_left,
              back_hood_right: verKeys.back_hood_right,
            });
            verOriginalKeys.back_text = (verHS && verHS.teamWallText) || ORIGINAL_IMAGES.back_text_text;
            verOriginalKeys.print_files = verPF || originalImagesKeys.print_files;
            productOriginalImages = keysToUrls(verOriginalKeys);
          } else if (pVer && verPF) {
            // Non-hoodie version (zip hoodie etc) with version-specific print files
            productOriginalImages = keysToUrls(
              Object.assign({}, originalImagesKeys, { print_files: verPF })
            );
          }
        }

        return {
          productId: p.productId,
          productData: p.productData,
          images: keysToUrls(p.images),
          originalImages: productOriginalImages
        };
      });

      // Step 3: Save creation job directly to S3 (bypasses Lambda 6MB payload limit)
      updateBgStatus("in-progress", "Saving job...");
      var jobKey = orderFolder + "/job.json";
      var jobUrlRes = await $.ajax({
        url: LAMBDA_URL,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify({ action: "get-upload-urls", keys: [jobKey], auth: _auth })
      });
      var jobUrlData = typeof jobUrlRes === "string" ? JSON.parse(jobUrlRes) : jobUrlRes;
      var jobPayload = JSON.stringify({
        products: batchProducts,
        manifest: manifest,
        first_name: customer_first_name,
        last_name: customer_last_name,
        projectName: projectNameVal,
        // Build the 78 cm film once the products exist. Staff-only, and the
        // lambda decides that (gang-film-plan checks STOCK_ADMIN_IDS), so a
        // flag set by anyone else is refused rather than trusted.
        buildFilm: !!(window.FtmFilm && window.FtmFilm.wanted()),
        status: "pending",
        createdAt: new Date().toISOString()
      });
      var jobPutRes = await fetch(jobUrlData.urls[jobKey], {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: jobPayload
      });
      if (!jobPutRes.ok) {
        throw new Error("Failed to save job.json to S3: " + jobPutRes.status);
      }
      console.log("Background: Creation job saved to S3 (" + (jobPayload.length / 1024).toFixed(1) + " KB)");

      // Step 4: create the Shopify products — or, in Local mode, don't.
      //
      // Everything above this point is local work in Local mode: the artwork
      // and mockups went to the SSD, job.json went to the SSD. Only this step
      // needs the network, and creating products is not what Local mode is
      // for. The print files are, and they never needed Shopify: the renderers
      // read a manifest, not a collection.
      //
      // So here we save the manifest and render the print files on the SSD,
      // and stop. job.json is left on disk exactly as Cloud mode wrote it, so
      // creating the products later (online, with the pill on Local — the
      // backend syncs the folder first) picks up from precisely this state.
      if (ftmLocalBackend()) {
        // The manifest is saved HERE and nowhere else on this path: draft
        // autosaves were stopped just before this function ran (so a late one
        // could not resurrect a promoted draft), and in Cloud mode the manifest
        // is written by process-creation-job in the lambda. Skip creation
        // without this and the renderer reads a stale manifest, or none.
        //
        // save-draft, not save-manifest: save-manifest requires a collectionId,
        // which a group that has never been created does not have. save-draft
        // already knows it is offline and skips the Shopify metafield write.
        updateBgStatus("in-progress", "Saving design locally…");
        await $.ajax({
          url: LAMBDA_URL, method: "POST", contentType: "application/json",
          data: JSON.stringify({
            action: "save-draft", manifest: manifest,
            projectName: projectNameVal, auth: _auth
          })
        });

        updateBgStatus("in-progress", "Rendering print files (no upload, this can take a few minutes)…");
        try {
          var renderRes = await $.ajax({
            url: LAMBDA_URL, method: "POST", contentType: "application/json",
            data: JSON.stringify({ action: "local-render-prints", orderFolder: orderFolder, auth: _auth })
          });
          var renderData = typeof renderRes === "string" ? JSON.parse(renderRes) : renderRes;
          if (!renderData || renderData.success === false) {
            throw new Error((renderData && renderData.error) || "render failed");
          }
          $overlay.addClass("success-state");
          $("#preview-header-text").text("Print files are ready");
          updateBgStatus("success",
            "Print files rendered locally in " + (renderData.seconds || "?") + "s. No products created.");
        } catch (renderErr) {
          console.error("Local print render failed:", renderErr);
          updateBgStatus("error",
            "Design saved, but rendering the print files failed. See the backend terminal.");
        }

        // Reveal the print downloads. In Cloud mode these wait for
        // process-creation-job to answer; here there is nothing to wait for.
        // Their data (_designSheetData, _bgCreationOrderFolder) was populated
        // before this function was even called, and every action behind them
        // is offline-capable — the gate was always sequencing, never data.
        $("#generate-rozpiska-btn, #download-section-zips-btn").show();
        $("#success-btn-home").show();
      } else {
        // job.json is the lambda run's from here (it marks it "processing"),
        // so "Try again" re-sends the trigger and never writes job.json again.
        window._bgCreationRetry = null;
        updateBgStatus("in-progress", "Creating products and print files...");
        fireBatchCreation(orderFolder, LAMBDA_URL, $overlay);
      }

    } catch (err) {
      window._s3UploadInProgress = false;
      console.error("Background creation error:", err);
      updateBgStatus("error", "Upload failed, try again");
    }
  }

  // Clean empty lines on blur but KEEP the pasted order — the wall renderers
  // pyramid-sort internally for display, while arm namelists and the golden
  // top-N option follow this list's order as typed.
  document
    .getElementById("back_middle_input")
    .addEventListener("blur", (e) => {
      const cleaned = e.target.value
        .split("\n")
        .map(v => v.trim())
        .filter(v => v)
        .join("\n");

      e.target.value = cleaned;
      ORIGINAL_IMAGES.back_text_text = cleaned;
    });


  // Color picker handler moved to product-creator-color-picker.js

  // Confirm and create/update - multi-product AJAX
  $(document).on("click", "#confirm-create-btn", async function() {
    const $btn = $(this);
    const isEditMode = window.EditMode && window.EditMode.isActive();

    $btn.prop("disabled", true);
    $btn.text(isEditMode ? "Updating..." : "Creating...");

    // Hide preview, show spinner
    $("#expansion-preview-overlay").removeClass("active");
    showGlobalSpinner({
      stages: [
        "Rendering your mockups…",
        "Compositing each color…",
        "Placing your artwork…",
        "Preparing the preview…"
      ],
      durationSeconds: 30
    });
    // Yield to let the browser paint the spinner before heavy canvas work
    await new Promise(function(r) { setTimeout(r, 50); });

    // =============================================
    // EDIT MODE: Update existing products
    // =============================================
    if (!_auth) {
      hideGlobalSpinner();
      alert("You must be logged in to create products. Log in and try again.");
      $btn.prop("disabled", false);
      $btn.text(isEditMode ? "Confirm & update" : "Confirm & create");
      return;
    }

    // Pre-save validation
    if (window.CustomizerValidator) {
      var hoodieIncludedForValidation = $("#hoodie-include-cb").is(":checked");
      var validationExpIds = [];
      $(".expansion-include-cb:checked").each(function() { validationExpIds.push($(this).data("product-id")); });
      var validationVerIds = [];
      $(".version-include-cb:checked").each(function() { validationVerIds.push($(this).data("version-id")); });

      var validation = window.CustomizerValidator.validateBeforeSave({
        originalImages: ORIGINAL_IMAGES,
        hoodieIncluded: hoodieIncludedForValidation,
        checkedExpansionIds: validationExpIds,
        checkedVersionIds: validationVerIds,
        projectName: (document.getElementById("project-name-input") || {}).value || "",
        hoodLeftMode: window.ImageUpload && window.ImageUpload.getHoodLeftMode ? window.ImageUpload.getHoodLeftMode() : "image",
        hoodRightMode: window.ImageUpload && window.ImageUpload.getHoodRightMode ? window.ImageUpload.getHoodRightMode() : "image",
        hoodLeftText: ($("#hood_left_text_input").val() || ""),
        hoodRightText: ($("#hood_right_text_input").val() || ""),
        uploadedData: window.UploadedEgennavnData
      });

      if (!validation.valid) {
        hideGlobalSpinner();
        window.CustomizerValidator.showValidationErrors(validation.errors);
        $btn.prop("disabled", false);
        $btn.text(isEditMode ? "Confirm & update" : "Confirm & create");
        return;
      }
      window.CustomizerValidator.hideValidationErrors();
    }

    // Mandatory egennavn upload before creating/updating products. Edit mode
    // passes when the saved manifest already carried perPersonRows (the
    // edit-mode loader restores window.UploadedEgennavnData from it), and
    // fails when the original product was created without an upload — at
    // which point the user must upload before saving.
    if (!window.UploadedEgennavnData) {
      hideGlobalSpinner();
      if (window.CustomizerValidator) {
        window.CustomizerValidator.showValidationErrors([
          { area: "egennavn", message: "Upload the custom names list (.xlsx) before you " + (isEditMode ? "update" : "create") + " products." }
        ]);
      } else {
        alert("Upload the custom names list (.xlsx) before creating products.");
      }
      $("#expansion-preview-overlay").addClass("active");
      $("#egennavn-upload-input").trigger("click");
      $btn.prop("disabled", false).text(isEditMode ? "Confirm & update" : "Confirm & create");
      return;
    }

    // Versions exist → variantskjema must be uploaded AND every included
    // version must claim ≥1 KATALOG token. Without these the lambda's
    // back-combined renderer falls back to base art for unclaimed surnames.
    var versionGate = window.validateVersionLabeling && window.validateVersionLabeling();
    if (versionGate && !versionGate.ok) {
      hideGlobalSpinner();
      if (window.applyKatalogCoverageUI) window.applyKatalogCoverageUI();
      $("#expansion-preview-overlay").addClass("active");
      if (window.CreatorUtils && window.CreatorUtils.showNotification) {
        window.CreatorUtils.showNotification("Assign variants", versionGate.reasons.join(" • "), null, "OK");
      } else {
        alert(versionGate.reasons.join("\n"));
      }
      if (versionGate.firstUnclaimedVersionId) {
        var $u = $("#preview-card-" + $.escapeSelector(String(versionGate.firstUnclaimedVersionId)));
        if ($u.length) {
          $u[0].scrollIntoView({ behavior: "smooth", block: "center" });
          $u.addClass("is-unclaimed");
        }
      }
      $btn.prop("disabled", false).text(isEditMode ? "Confirm & update" : "Confirm & create");
      return;
    }

    if (isEditMode) {
      try {
        await window.EditHandler.handleSubmission({
          $btn: $btn,
          auth: _auth,
          customerId: customerId,
          customerNameSplit: customer_name_split,
          originalImages: ORIGINAL_IMAGES,
          projectName: (document.getElementById("project-name-input") || {}).value || "",
          showGlobalSpinner: showGlobalSpinner,
          hideGlobalSpinner: hideGlobalSpinner,
          updateBgStatus: updateBgStatus
        });
      } catch (err) {
        hideGlobalSpinner();
        console.error("Edit mode update error:", err);
        alert("Something went wrong while updating. Try again.");
        updateBgStatus("error", "Something went wrong");
        $btn.prop("disabled", false);
        $btn.text("Confirm & update");
      }
      return; // Don't continue to creation flow
    }

    // =============================================
    // NORMAL CREATION FLOW (below)
    // =============================================

    try {
      // Ensure active product is hoodie for correct box lookups during export
      window.ProductConfig.setActiveProductId("hoodie");

      // Check if hoodie is included
      var hoodieIncluded = $("#hoodie-include-cb").is(":checked");

      // Export all variant images for hoodie (only if included)
      let hoodieImages = {};
      if (hoodieIncluded) {
        try {
          hoodieImages = await exportAllVariantImages();
        } catch (exportError) {
          console.error("Hoodie export failed:", exportError);
          hoodieImages = {
            "Default": {
              front: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==",
              back: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
            }
          };
        }
      }

      // Export all variant images for checked expansion products
      var expansionExports = {};
      var checkedExpansionIds = [];
      $(".expansion-include-cb:checked").each(function() {
        checkedExpansionIds.push($(this).data("product-id"));
      });

      if (window.ExpansionRenderer) {
        var expPromises = checkedExpansionIds.map(function(expId) {
          var editedItems = window.EXPANSION_EDITED_ITEMS && window.EXPANSION_EDITED_ITEMS[expId];
          var exportFn = (editedItems && editedItems.length > 0)
            ? window.ExpansionRenderer.exportFromEditedItems(expId, editedItems)
            : window.ExpansionRenderer.exportProductImages(expId);
          return exportFn.then(function(result) {
            return { expId: expId, result: result };
          }).catch(function(err) {
            console.error(expId + " export failed:", err);
            return { expId: expId, result: null };
          });
        });
        var expResults = await Promise.all(expPromises);
        expResults.forEach(function(r) {
          if (r.result) expansionExports[r.expId] = r.result;
        });
      }

      // Export included versions
      var versionExports = {};
      var checkedVersionIds = [];
      if (window.VersionManager) {
        var allVersions = window.VersionManager.getAllVersions();
        allVersions.forEach(function(ver) {
          if (!ver.included) return;
          checkedVersionIds.push(ver.versionId);
        });

        // Pass 1: Hoodie versions — NON-MUTATING via exportAllVariantImages(opts)
        // Passes version items and state as opts instead of swapping globals.
        var baseDesignItems = window.DESIGN.state.getActiveItems();
        for (var vi = 0; vi < checkedVersionIds.length; vi++) {
          var vId = checkedVersionIds[vi];
          var ver = window.VersionManager.getVersion(vId);
          if (!ver || ver.baseProductId !== "hoodie") continue;

          try {
            window.ProductConfig.setActiveProductId("hoodie");

            var verItems = ver.editedItems && ver.editedItems.length > 0
              ? deepCloneDesignItems(ver.editedItems) : deepCloneDesignItems(baseDesignItems);
            // Wait for all version item images to load before exporting
            await Promise.all(verItems.map(function(item) {
              if (!item.img || !item.img.src) return Promise.resolve();
              return new Promise(function(resolve) {
                var newImg = new Image();
                newImg.crossOrigin = "anonymous";
                newImg.onload = function() { item.img = newImg; resolve(); };
                newImg.onerror = function() { resolve(); };
                newImg.src = item.img.src;
              });
            }));

            var verHS = window.VersionManager.getHoodieState(vId);

            // Export with version state passed as opts — no global mutation needed
            versionExports[vId] = await exportAllVariantImages({
              items: verItems,
              variantLogos: verHS ? verHS.variantLogos : null,
              teamWallText: verHS ? verHS.teamWallText : undefined,
              hoodLeftText: verHS ? verHS.hoodLeftText : undefined,
              hoodRightText: verHS ? verHS.hoodRightText : undefined,
              hoodLeftMode: verHS ? verHS.hoodLeftMode : undefined,
              hoodRightMode: verHS ? verHS.hoodRightMode : undefined
            });
          } catch (exportError) {
            console.error(vId + " hoodie version export failed:", exportError);
          }
        }

        // Pass 2: Expansion versions (parallel — independent offscreen renders)
        if (window.ExpansionRenderer) {
          var expVersionPromises = [];
          for (var vi2 = 0; vi2 < checkedVersionIds.length; vi2++) {
            var vId2 = checkedVersionIds[vi2];
            var ver2 = window.VersionManager.getVersion(vId2);
            if (!ver2 || ver2.baseProductId === "hoodie") continue;

            expVersionPromises.push((function(capturedVId, capturedVer) {
              var fn = (capturedVer.editedItems && capturedVer.editedItems.length > 0)
                ? window.ExpansionRenderer.exportFromEditedItems(capturedVer.baseProductId, capturedVer.editedItems, capturedVId)
                : window.ExpansionRenderer.exportProductImages(capturedVer.baseProductId, capturedVId);
              return fn.then(function(result) {
                return { vId: capturedVId, result: result };
              }).catch(function(err) {
                console.error(capturedVId + " expansion version export failed:", err);
                return { vId: capturedVId, result: null };
              });
            })(vId2, ver2));
          }
          var vExpResults = await Promise.all(expVersionPromises);
          vExpResults.forEach(function(r) {
            if (r.result) versionExports[r.vId] = r.result;
          });
        }
      }

      // Read project name from DOM before building product data
      var projectNameVal = (document.getElementById("project-name-input") || {}).value || "";

      // Build hoodie product data
      const hoodieProduct = {
        title: window.CUSTOMIZER_PRODUCT.title + '-' + projectNameVal,
        customer_name: customer_name_split,
        customer_id: customerId,
        body_html: window.CUSTOMIZER_PRODUCT.body_html,
        vendor: window.CUSTOMIZER_PRODUCT.vendor,
        product_type: window.CUSTOMIZER_PRODUCT.product_type,
        tags: `customize-product,cid_${customerId}`,
        options: window.CUSTOMIZER_PRODUCT.options,
        variants: window.CUSTOMIZER_PRODUCT.variants,
        price: window.CUSTOMIZER_PRODUCT.price,
        handle: window.CUSTOMIZER_PRODUCT.handle
      };

      // Upload images to S3 first (via presigned URLs), then create products with S3 URLs
      const LAMBDA_URL = window.FTM_CONFIG.LAMBDA_PRODUCT_CREATE;
      // Reuse the draft's orderFolder if this order was autosaved as a draft, so
      // the already-uploaded design files aren't duplicated and process-creation-job
      // can promote the draft (drop it from "Utkast"). Otherwise mint a fresh one.
      const orderFolder = (window.ProductCreatorDraft && window.ProductCreatorDraft.getOrderFolder)
        ? window.ProductCreatorDraft.getOrderFolder(projectNameVal)
        : `orders/${customerId}/${projectNameVal.replace(/[^a-zA-Z0-9_-]/g, '_').substring(0, 50)}_${Date.now()}`;

      // Collect all base64 images from all products and originalImages
      const imageMap = {}; // key -> base64 data URL

      // Creation emits a design file per colour per product, so every colour's
      // artwork must be in memory. After a lazy draft restore most of it is still
      // just S3 keys, so pay the download here, behind visible progress. Rejects
      // if the user cancels, the outer catch aborts creation rather than shipping
      // incomplete print files.
      await window.CreatorUtils.ensureArtworkReady("Preparing artwork for creation…");

      // Before collecting design files, ensure VARIANT_LOGOS is in sync with current ORIGINAL_IMAGES
      if (window.VariantLogoUtil) {
        window.VariantLogoUtil.saveToVariant(window.VariantLogoUtil.getCurrentColor());
      }

      // Collect all design files via shared module
      var variantColors = window.variantData ? [...new Set(window.variantData.map(function(v) { return v.color; }))] : [];

      // For text-mode hoods, mint a correctly-tinted PNG per color BEFORE
      // fanout runs. fanoutToColors() blanket-copies the source-color dataUrl
      // to every other color, so without this pre-step a "KK" typed while
      // viewing Light grey would land in every variant — including Navy —
      // as a dark-text PNG, and dark-garment variants would print unreadable.
      if (window.VariantLogoUtil && window.VariantLogoUtil.populateHoodTextPerColor) {
        var _hoodLeftMode = window.ImageUpload && window.ImageUpload.getHoodLeftMode ? window.ImageUpload.getHoodLeftMode() : "image";
        var _hoodRightMode = window.ImageUpload && window.ImageUpload.getHoodRightMode ? window.ImageUpload.getHoodRightMode() : "image";
        var _hoodLeftText = ($("#hood_left_text_input").val() || "").trim();
        var _hoodRightText = ($("#hood_right_text_input").val() || "").trim();
        if (_hoodLeftMode === "text" && _hoodLeftText) {
          await window.VariantLogoUtil.populateHoodTextPerColor("left", _hoodLeftText, variantColors);
        }
        if (_hoodRightMode === "text" && _hoodRightText) {
          await window.VariantLogoUtil.populateHoodTextPerColor("right", _hoodRightText, variantColors);
        }
      }

      // Auto-apply the user's customization to every saleable variant color.
      // Colors with their own explicit edits keep them; empty colors inherit.
      // (For text-mode hoods every color was just explicitly populated above,
      // so fanout is a no-op for back_hood_<side> and only does its real work
      // for image-mode fields like front_image, back_top, etc.)
      if (window.VariantLogoUtil) {
        window.VariantLogoUtil.fanoutToColors(variantColors);
      }
      var collected = DesignCollector.collectAll({
        orderFolder: orderFolder,
        imageMap: imageMap,
        originalImages: ORIGINAL_IMAGES,
        variantLogos: window.VARIANT_LOGOS,
        expansionVariantLogos: window.EXPANSION_VARIANT_LOGOS,
        excludedSlotsByExpansion: window.EXPANSION_EXCLUDED_SLOTS || {},
        excludedSlotsByColorByExpansion: window.EXPANSION_EXCLUDED_BY_COLOR || {},
        variantColors: variantColors,
        checkedExpansionIds: checkedExpansionIds,
        checkedVersionIds: checkedVersionIds,
        hoodLeftMode: window.ImageUpload && window.ImageUpload.getHoodLeftMode ? window.ImageUpload.getHoodLeftMode() : "image",
        hoodRightMode: window.ImageUpload && window.ImageUpload.getHoodRightMode ? window.ImageUpload.getHoodRightMode() : "image",
        hoodLeftText: ($("#hood_left_text_input").val() || ""),
        hoodRightText: ($("#hood_right_text_input").val() || "")
      });

      // Generate all print files via shared module
      var printResult = await window.PrintGenerator.generateAll({
        orderFolder: orderFolder,
        imageMap: imageMap,
        originalImages: ORIGINAL_IMAGES,
        checkedExpansionIds: checkedExpansionIds,
        checkedVersionIds: checkedVersionIds,
        hoodLeftMode: window.ImageUpload && window.ImageUpload.getHoodLeftMode ? window.ImageUpload.getHoodLeftMode() : "image",
        hoodRightMode: window.ImageUpload && window.ImageUpload.getHoodRightMode ? window.ImageUpload.getHoodRightMode() : "image",
        hoodLeftText: ($("#hood_left_text_input").val() || ""),
        hoodRightText: ($("#hood_right_text_input").val() || "")
      });
      var printFilesKeys = printResult.printFilesKeys;
      var versionPrintFiles = printResult.versionPrintFiles;

      // Original image keys for Lambda metafields (first hoodie copy serves as the URL).
      //
      // Only slots the collector actually wrote are named. Both hoods are
      // optional — a group can take the left, the right, or neither — and
      // claiming all four unconditionally produced URLs to files that were never
      // uploaded. Harmless in the cloud (the artwork metafields are type "url",
      // so Shopify stores the string without fetching it) but it made the local
      // backend's scoped upload look for a file that is not on disk, and it
      // leaves a dead link in `custom.hood_left_artwork` for the customizer to
      // find when the order is reopened. Kvinnherad shipped nine of these.
      const designKeys = (collected && collected.designKeys && collected.designKeys.hoodie) || {};
      const originalImagesKeys = window.FTMShared.omitEmptySlots({
        front_image: designKeys.front_image,
        back_top: designKeys.back_top,
        back_hood_left: designKeys.back_hood_left,
        back_hood_right: designKeys.back_hood_right,
      });
      originalImagesKeys.back_text = ORIGINAL_IMAGES.back_text_text;
      originalImagesKeys.print_files = printFilesKeys;

      const productsToCreate = [];
      if (hoodieIncluded) {
        productsToCreate.push({ productId: "hoodie", productData: hoodieProduct, images: hoodieImages });
      }

      // Add checked expansion products
      checkedExpansionIds.forEach(function(expId) {
        var expProductData = window.EXPANSION_PRODUCT_DATA && window.EXPANSION_PRODUCT_DATA[expId];
        var expImages = expansionExports[expId];
        if (expProductData && Array.isArray(expProductData.variants) && expProductData.variants.length > 0 && expImages && Object.keys(expImages).length > 0) {
          productsToCreate.push({
            productId: expId,
            productData: {
              title: expProductData.title + '-' + projectNameVal,
              customer_name: customer_name_split,
              customer_id: customerId,
              body_html: expProductData.body_html,
              vendor: expProductData.vendor,
              product_type: expProductData.product_type,
              tags: `customize-product,cid_${customerId}`,
              options: expProductData.options,
              variants: expProductData.variants,
              price: expProductData.price,
              handle: expProductData.handle
            },
            images: expImages
          });
        }
      });

      // Add included versions as separate products
      checkedVersionIds.forEach(function(vId) {
        var ver = window.VersionManager.getVersion(vId);
        if (!ver) return;
        var verImages = versionExports[vId];

        if (ver.baseProductId === "hoodie") {
          // Hoodie version: use CUSTOMIZER_PRODUCT as template
          if (verImages && Object.keys(verImages).length > 0) {
            productsToCreate.push({
              productId: vId,
              productData: {
                title: window.CUSTOMIZER_PRODUCT.title + '-' + projectNameVal + ' (Versjon ' + (ver.versionNumber + 1) + ')',
                customer_name: customer_name_split,
                customer_id: customerId,
                body_html: window.CUSTOMIZER_PRODUCT.body_html,
                vendor: window.CUSTOMIZER_PRODUCT.vendor,
                product_type: window.CUSTOMIZER_PRODUCT.product_type,
                tags: `customize-product,cid_${customerId}`,
                options: window.CUSTOMIZER_PRODUCT.options,
                variants: window.CUSTOMIZER_PRODUCT.variants,
                price: window.CUSTOMIZER_PRODUCT.price,
                handle: window.CUSTOMIZER_PRODUCT.handle
              },
              images: verImages
            });
          } else {
            console.warn("Version " + vId + " (hoodie) excluded: no images exported", verImages);
          }
          return;
        }

        // Expansion version
        var baseProductData = window.EXPANSION_PRODUCT_DATA && window.EXPANSION_PRODUCT_DATA[ver.baseProductId];
        if (baseProductData && verImages && Object.keys(verImages).length > 0) {
          productsToCreate.push({
            productId: vId,
            productData: {
              title: baseProductData.title + '-' + projectNameVal + ' (Versjon ' + (ver.versionNumber + 1) + ')',
              customer_name: customer_name_split,
              customer_id: customerId,
              body_html: baseProductData.body_html,
              vendor: baseProductData.vendor,
              product_type: baseProductData.product_type,
              tags: `customize-product,cid_${customerId}`,
              options: baseProductData.options,
              variants: baseProductData.variants,
              price: baseProductData.price,
              handle: baseProductData.handle
            },
            images: verImages
          });
        } else {
          console.warn("Version " + vId + " (expansion:" + ver.baseProductId + ") excluded: no images or missing product data", verImages, baseProductData);
        }
      });

      // Store data URLs for eager download (before S3 upload replaces them with keys)
      window._mockupDataUrls = productsToCreate.map(function(p) {
        return { productId: p.productId, images: p.images };
      });

      const productsWithKeys = productsToCreate.map(p => ({
        productId: p.productId,
        productData: p.productData,
        images: DesignCollector.collectMockupImages(p.images, p.productId, imageMap, orderFolder)
      }));

      // === REVIEW GATE: every mockup (product × color × view) is rendered and
      // in memory, nothing is uploaded yet. Wait for explicit approval.
      // FAIL CLOSED: if the review module is missing (stale cached page),
      // refuse to create rather than skipping the review. ===
      hideGlobalSpinner();
      if (!window.CreatorReview || !window.CreatorReview.open) {
        alert("The review step could not load. Refresh the page and try again.");
        $("#expansion-preview-overlay").addClass("active");
        $btn.prop("disabled", false);
        $btn.text("Confirm & create");
        return;
      }
      var reviewApproved = await window.CreatorReview.open(window._mockupDataUrls);
      if (!reviewApproved) {
        // Go back: return to the preview overlay — nothing uploaded or created
        $("#expansion-preview-overlay").addClass("active");
        $btn.prop("disabled", false);
        $btn.text("Confirm & create");
        return;
      }
      showGlobalSpinner({
        stages: [
          "Finalizing your design…",
          "Uploading your artwork…",
          "Getting things ready…"
        ],
        durationSeconds: 20
      });
      await new Promise(function(r) { setTimeout(r, 50); });

      // === FOREGROUND: Build manifest while DOM is still available ===
      var manifest = buildManifest({
        orderFolder: orderFolder,
        collectionId: "",
        collectionHandle: "",
        allResults: [],
        checkedExpansionIds: checkedExpansionIds,
        checkedVersionIds: checkedVersionIds
      });
      // Surface designer-intent issues: a version with one color customised
      // but its sibling left empty will print the populated color's artwork on
      // both garments via the lambda's cross-color fallback. Block save with
      // a confirm() so the user explicitly acknowledges the cross-color reuse
      // (or aborts and fills in the missing color before re-saving).
      if (window.detectVersionAsymmetry) {
        var asymmetryWarnings = window.detectVersionAsymmetry(manifest);
        if (asymmetryWarnings && asymmetryWarnings.length) {
          console.warn("Asymmetric V2 colors detected:", asymmetryWarnings);
          var lines = asymmetryWarnings.map(function (w) {
            return "• " + w.versionId + ": designed only for " + w.populatedColors.join(", ") +
              "; " + w.missingColors.join(", ") + " will use the same design.";
          });
          var msg = "Some versions only have a design for one color:\n\n" + lines.join("\n") +
            "\n\nThe cross-color fallback will use the populated design on both colors." +
            "\n\nPress OK to continue with the same design on both colors." +
            "\nPress Cancel to go back and add a design for the other color.";
          if (!window.confirm(msg)) {
            hideGlobalSpinner();
            $("#expansion-preview-overlay").addClass("active");
            $btn.prop("disabled", false);
            $btn.text("Confirm & create");
            return;
          }
          manifest.designerWarnings = (manifest.designerWarnings || []).concat(
            asymmetryWarnings.map(function (w) {
              return {
                type: "version-asymmetry",
                versionId: w.versionId,
                populatedColors: w.populatedColors,
                missingColors: w.missingColors,
                acknowledgedAt: new Date().toISOString(),
              };
            })
          );
        }
      }
      // Upload variant logos to S3 (keeps request under Lambda 20MB limit)
      manifest = await extractVariantLogosToS3(manifest, orderFolder, LAMBDA_URL);

      // projectNameVal already captured before product data construction above

      // === END FOREGROUND: hide spinner, show mockups immediately ===
      hideGlobalSpinner();

      var $overlay = $("#expansion-preview-overlay");
      $overlay.addClass("active downloads-ready");
      $("#preview-header-text").text("Mockups are ready!");
      $("#bg-creation-status").show();
      updateBgStatus("in-progress", "Uploading images...");

      // Store orderFolder for retry
      window._bgCreationOrderFolder = orderFolder;
      window._bgCreationLambdaUrl = LAMBDA_URL;

      // Store data for design sheet generation
      var nameText = ORIGINAL_IMAGES.back_text_text || $("#back_middle_input").val() || "";
      var dsNamesList = nameText.split(/\r?\n/).map(function(n) { return n.trim(); }).filter(Boolean);
      var dsProducts = productsToCreate.map(function(p) {
        var label = getProductLabel(p.productId);
        var colors = p.images ? Object.keys(p.images) : [];
        var designKeys = {};
        var prefix = orderFolder + "/designs/" + p.productId + "/";
        Object.keys(imageMap).forEach(function(k) {
          if (k.startsWith(prefix)) {
            var placement = k.replace(prefix, "").replace(".png", "");
            designKeys[placement] = k;
          }
        });
        // Resolve productType: versioned IDs → baseProductId, otherwise use productId directly
        var productType = p.productId;
        if (window.VersionManager && window.VersionManager.isVersionedId(p.productId)) {
          var ver = window.VersionManager.getVersion(p.productId);
          if (ver) productType = ver.baseProductId;
        }
        return { productId: p.productId, label: label, colors: colors, designKeys: designKeys, productType: productType };
      });
      window._designSheetData = {
        orderFolder: orderFolder,
        projectName: projectNameVal,
        products: dsProducts,
        printFiles: printFilesKeys,
        namesList: dsNamesList
      };
      console.log("[DesignSheet] _designSheetData set:", {
        orderFolder: window._designSheetData.orderFolder,
        productCount: window._designSheetData.products.length,
        productIds: window._designSheetData.products.map(function(p) { return p.productId; }),
        printFileKeys: Object.keys(window._designSheetData.printFiles || {})
      });

      // Order is now being created → stop draft autosaves so a late one can't
      // re-add the draft after process-creation-job promotes (removes) it.
      if (window.ProductCreatorDraft && window.ProductCreatorDraft.stop) {
        window.ProductCreatorDraft.stop();
      }

      // === BACKGROUND (fire-and-forget): S3 upload + save job + trigger creation ===
      runNavigationSafeCreation({
        imageMap: imageMap,
        productsWithKeys: productsWithKeys,
        originalImagesKeys: originalImagesKeys,
        orderFolder: orderFolder,
        manifest: manifest,
        projectNameVal: projectNameVal,
        LAMBDA_URL: LAMBDA_URL,
        $overlay: $overlay,
        versionPrintFiles: versionPrintFiles,
        // Which artwork slots the collector actually wrote, per product/version.
        // Needed here so the per-version originalImages can name optional hoods
        // only when they exist, exactly as the base product does.
        designKeys: (collected && collected.designKeys) || {}
      });

    } catch (err) {
      hideGlobalSpinner();
      console.error("Multi-product creation error:", err);
      alert("Something went wrong while preparing the products. Try again.");
      var $overlay = $("#expansion-preview-overlay");
      $overlay.addClass("active");
      $("#preview-header-text").text("Product preview");
      $btn.prop("disabled", false);
      $btn.text("Confirm & create");
    }
  });

  // Download handlers moved to product-creator-downloads.js

  // Inject "Start designing" button on customizer template products
  const tag_product = window.PRODUCT_TAGS;
  if (tag_product && tag_product.includes("customizer")) {
    if ($('.product__info form').length) {
      $('.product__info form').after(`
        <button id="customize-button" type="button" style="display:block !important;">
          Start designing
        </button>
      `);
    } else if ($('.buy-buttons').length) {
      $('.buy-buttons').after(`
        <button id="customize-button" type="button" style="display:block !important;">
          Start designing
        </button>
      `);
    }
  }

  // =============================================
  // EDIT MODE / DRAFT RESUME AUTO-START
  // =============================================
  // Both ?edit=<handle> (created order) and ?draft=<orderFolder> (work-in-progress)
  // restore via startEditMode; the loader keeps _isActive false for drafts so the
  // confirm button still runs the normal creation flow.
  // Single-product pages run their own editor + their own ?draft= resume, so the
  // hoodie restore must not auto-start there.
  var isSingleProductPage = window.SINGLE_PRODUCT && window.SINGLE_PRODUCT.enabled;
  if (!isSingleProductPage && window.EditMode && (window.EditMode.isActive() || window.EditMode.isDraft())) {
    // Wait a bit for all modules to initialize
    setTimeout(function() {
      window.EditMode.startEditMode(_auth);
    }, 600);
  }

});
